import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  news: {},
};

export const handleUpdateNewsData = (state, { locale, data }) => {
  const news = { ...state.news, [locale]: data };
  return { ...state, news };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_NEWS_DATA:
      return handleUpdateNewsData(state, action);
    default:
      return state;
  }
};
